import assignWith from 'lodash/assignWith';
import Dealer from 'models/dealer';
import dealerApi from 'api/dealer';
import events from 'lib/events';
import FooterButton from 'components/layout/footerButton';
import FooterEditButton from 'components/layout/footerEditButton';
import hopscotch from 'hopscotch';
import NewPlasterText from './AnalysisPreferences/NewPlasterText';
import PageFooter from 'components/layout/pageFooter';
import PreferenceOptions from './AnalysisPreferences/PreferenceOptions';
import ProductApi from 'api/product';
import React from 'react';
import session from 'services/sessionService';
import throttle from 'lodash/throttle';
import ValidationGroup from 'helpers/validation';
import {dealerAdminTourFormat, userLevels} from 'helpers/constants';
import {intlShape, injectIntl} from 'react-intl';
import {deleteSuggestedProducts} from 'api/suggestedProduct';

let assignHelper = (defaultVal, newVal) => defaultVal && (newVal === null || newVal === undefined) ? defaultVal : newVal;

class AnalysisPreferences extends React.Component {
  constructor(props) {
    super(props);
    let newDealer = new Dealer({
      balanceCHTo: 'Use LSI',
      inSeasonTABalanceTarget: '135',
      smartShockMinSize: '1',
      nonFoamingAlgicide: 'Banish',
      defaultHazyProduct: '18100',
      overrideOxidizer: 'BurnOut 73',
    });

    this.state = {
      dealer: newDealer.clone(),
      dealerWorkingCopy: newDealer.clone(),
      edit: false,
      originalSuggestedProducts: null,
      products: [],
      showNewPlaster: false,
      suggestedProducts: null,
    };
  }

  componentWillMount() {
    this.group = new ValidationGroup(this.savePrefs);
  }

  componentDidMount() {
    Promise.all([
      dealerApi.getDealer(session.getUser().dealerId),
      ProductApi.getProducts()])
    .then(([dealer, products]) => {
      // Merge with existing one so if values are somehow null (old/imported/etc) then it gets set to default.
      this.setState({
        dealer: assignWith(this.state.dealer, dealer.clone(), assignHelper),
        dealerWorkingCopy: assignWith(this.state.dealerWorkingCopy, dealer.clone(), assignHelper),
        products,
      });
    });

    if (hopscotch.getState() === 'dealerAdmin:16') {
      hopscotch.startTour(dealerAdminTourFormat(this.props.intl.formatMessage), 16);
    }
  }

  componentWillUnmount() {
    if (hopscotch.isActive && window.location.hash !== '#settings/customer' && window.location.hash !== '#tools') {
      hopscotch.endTour();
    }
  }

  cancelEdit = () => {
    this.setState({
      dealerWorkingCopy: this.state.dealer.clone(),
      edit: false,
    });
    if(!this.state.suggestedProducts || !this.state.suggestedProducts.length) {
      this.setState({suggestedProducts: this.state.originalSuggestedProducts});
    }
  };

  dataChanged = (e) => {
    let dealer = this.state.dealerWorkingCopy.clone();

    dealer[e.key] = e.value;

    this.setState({dealerWorkingCopy: dealer});
  };

  saveNewPlaster = () => {
    let dealer = this.state.dealer.clone();

    dealer.newPlasterText = this.state.dealerWorkingCopy.newPlasterText;
    dealerApi.saveDealer(dealer)
      .then(d => {
        this.setState({
          dealer: d,
          showNewPlaster: false,
        });
      });
  };

  savePrefs = () => {
    dealerApi.saveDealer(this.state.dealerWorkingCopy)
      .then(dealer => {
        this.setState({
          dealer: assignWith(this.state.dealer, dealer.clone(), assignHelper),
          dealerWorkingCopy: assignWith(this.state.dealerWorkingCopy, dealer.clone(), assignHelper),
          edit: false,
        });
      })
      .catch(err => events.publish('error.user', {message: err}));

    if(!this.state.suggestedProducts || !this.state.suggestedProducts.length) {
      deleteSuggestedProducts()
        .then(() => this.setState({suggestedProducts: null}))
        .catch(e => console.error(e));
    }
  };

  startEdit = () => {
    this.setState({
      dealerWorkingCopy: this.state.dealer.clone(),
      edit: true,
    });
  };

  toggleNewPlaster = () => {
    let dealer = this.state.dealerWorkingCopy.clone();

    dealer.newPlasterText = this.state.dealer.newPlasterText;
    this.setState({
      dealerWorkingCopy: dealer,
      showNewPlaster: !this.state.showNewPlaster,
    });
  };

  updateSuggestedProducts = (products, updateOriginal) => {
    let original = updateOriginal ? products : this.state.originalSuggestedProducts;

    this.setState({
      originalSuggestedProducts: original,
      suggestedProducts: products,
    });
  };

  render() {
    let footer;

    if (session.getUser().privileges.level >= userLevels.dealerAdmin) {
      footer =
        <PageFooter>
          <FooterEditButton className='footer-item'
                            onCancel={this.cancelEdit} onSave={this.group.validate}
                            onEdit={this.startEdit} editMode={this.state.edit} />
          <FooterButton label={this.props.intl.formatMessage({id: 'footer.new.plaster.startup'})} icon='bl bl-text fa-2x' onClick={this.toggleNewPlaster} />
        </PageFooter>
      ;
    }

    return (
      <div className='analysis-preferences'>
        <PreferenceOptions
          dataChanged={this.dataChanged}
          dealer={this.state.dealerWorkingCopy}
          edit={this.state.edit}
          group={this.group}
          products={this.state.products}
          suggestedProducts={this.state.suggestedProducts}
          updateSuggestedProducts={this.updateSuggestedProducts}
        />
        <div className='clearfix' />
        <NewPlasterText plasterText={this.state.dealerWorkingCopy.newPlasterText} dataChanged={throttle(this.dataChanged, 250)}
                        visible={this.state.showNewPlaster} toggleNewPlaster={this.toggleNewPlaster} saveNewPlaster={this.saveNewPlaster} />
        {footer}
      </div>
    );
  }
}

export default injectIntl(AnalysisPreferences);
